module.exports = __webpack_public_path__ + "static/img/zt4_tab6.b718bbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt4_tab6.jpg
// module id = S0Ux
// module chunks = 171